var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59342 12.51L13.4234 16.49M13.4134 5.51L6.59342 9.49M19.0034 4C19.0034 5.65685 17.6603 7 16.0034 7C14.3466 7 13.0034 5.65685 13.0034 4C13.0034 2.34315 14.3466 1 16.0034 1C17.6603 1 19.0034 2.34315 19.0034 4ZM7.00342 11C7.00342 12.6569 5.66027 14 4.00342 14C2.34656 14 1.00342 12.6569 1.00342 11C1.00342 9.34315 2.34656 8 4.00342 8C5.66027 8 7.00342 9.34315 7.00342 11ZM19.0034 18C19.0034 19.6569 17.6603 21 16.0034 21C14.3466 21 13.0034 19.6569 13.0034 18C13.0034 16.3431 14.3466 15 16.0034 15C17.6603 15 19.0034 16.3431 19.0034 18Z",
    stroke: "#176FC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.b1a66391f2489624004dcc7e56cf6bf4.svg";
export { ForwardRef as ReactComponent };